import { useCallback } from 'react';
import { useDfContext } from '../context/df-context';

export function useFilterlabel() {
  const {
    state: {
      attributes,
      filterAttributes: { filterAttributeGroup },
    },
  } = useDfContext();

  const getFilterLabel = useCallback(
    (key: string) => {
      return attributes
        .find((attr) => attr.pimId === filterAttributeGroup)
        ?.children.find((item) => item.facetname === key)?.displayname;
    },
    [attributes, filterAttributeGroup],
  );

  const langLabel = getFilterLabel('dfAttributeDfLanguage');

  const fileLabel = getFilterLabel('dfAttributeDfFileType');

  return { langLabel, fileLabel, getFilterLabel };
}
